"use client";

import { Button } from "@dafiti/closet-ui";
import { Chevron, Loading } from "@dafiti/closet-ui/icons";
import { useTranslations } from "next-intl";

type Props = {
  isLastPage: boolean;
  isFetchingMore: boolean;
  onLoadMore?: () => void;
};

export function WishlistLoadMore({
  isLastPage,
  isFetchingMore,
  onLoadMore,
}: Props) {
  const t = useTranslations("wishlist");

  return (
    <>
      {isLastPage ? (
        <p className="lg:hidden text-center text-xs text-black pt-6 pb-1">
          {t("loadMore.endOfList")}
        </p>
      ) : null}

      <div className="lg:hidden flex justify-center pt-2xs pb-3xs">
        {!isLastPage ? (
          <Button
            className="max-w-30 w-full flex px-2"
            variant="secondary"
            size="sm"
            disabled={isFetchingMore}
            onClick={() => onLoadMore?.()}
            data-testid="wishlist-load-more"
          >
            {isFetchingMore ? (
              <div className="w-6 h-6 flex items-center justify-center">
                <Loading className="size-4 text-black" />
              </div>
            ) : (
              <>
                <span className="ml-2">{t("loadMore.more")}</span>

                <div className="w-6 h-6 flex items-center justify-center ml-1">
                  <Chevron className="size-2 rotate-180 shrink-0" />
                </div>
              </>
            )}
          </Button>
        ) : null}
      </div>
    </>
  );
}
